import cn from 'classnames/bind';
import React, { FC, useCallback, useState } from 'react';

import { Image } from '@/scenarios/legacy-player/ui/Image';

import { MetaMode, MetaProps, SubTitleViewVariant } from './Meta.types';
import styles from './Meta.module.css';

const cx = cn.bind(styles);

const FILM_LOGO_URL_SIZE = '960x540';

export const Meta: FC<MetaProps> = (props) => {
    const {
        className,
        title,
        subTitle,
        logoUrl,
        logoWidth,
        logoHeight,
        titleLines = 2,
        isNeedPlaceholder = true,
        mode = MetaMode.DEFAULT,
        subTitleViewVariant = SubTitleViewVariant.Regular,
        editorAnnotation,
    } = props;

    const [isImageLoadingFinished, setIsImageLoadingFinished] = useState(false);
    const isUserVote = mode === MetaMode.USER_VOTE;

    const textPlaceholderClassname =
        mode === MetaMode.USER_VOTE ? 'placeholder-vote' : 'placeholder';

    let isHorizontal = false;

    if (logoWidth && logoHeight) {
        isHorizontal = logoWidth >= logoHeight;
    }

    const textPlaceholder = (
        <div
            style={{
                WebkitLineClamp: titleLines,
            }}
            className={cx(textPlaceholderClassname)}
        >
            {title}
        </div>
    );

    const handleImageLoadingFinished = useCallback(() => {
        setIsImageLoadingFinished(true);
    }, []);

    const placeholder = isNeedPlaceholder ? textPlaceholder : undefined;

    return (
        <div
            className={cx('root', className, {
                visible: !logoUrl || isImageLoadingFinished,
            })}
        >
            {logoUrl ? (
                <div className={cx('logo')}>
                    <Image
                        imageUrl={logoUrl}
                        imageClassName={cx('image', {
                            image_horizontal: isHorizontal,
                            image_vertical: !isHorizontal,
                            image_loading: !isImageLoadingFinished,
                        })}
                        placeholderResolution={FILM_LOGO_URL_SIZE}
                        resolution={FILM_LOGO_URL_SIZE}
                        customPlaceholder={placeholder}
                        isAnimationAllowed={false}
                        onLoaded={handleImageLoadingFinished}
                        onError={handleImageLoadingFinished}
                        alt={title}
                    />
                </div>
            ) : (
                textPlaceholder
            )}
            {!isUserVote && (
                <div className={cx('extraInfo')}>
                    {subTitle && (
                        <div
                            className={cx('subtitle', {
                                subtitle_medium: subTitleViewVariant === SubTitleViewVariant.Medium,
                            })}
                        >
                            {subTitle}
                        </div>
                    )}
                    {editorAnnotation && (
                        <div className={cx('editorAnnotation')}>{editorAnnotation}</div>
                    )}
                </div>
            )}
        </div>
    );
};
